import { onMounted, onUnmounted } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { InputMessageThreadMarkRead } from "@scrile/api-provider/dist/api/MessageThreadsProvider";
import providers from "@/lib/api";
import emitter from "@/lib/emitter";
import { EVENTS } from "@/const";

export default function useWatchMarkReadMessage() {
  const markRead = async (message?: Message) => {
    if (!message) return;
    const data: InputMessageThreadMarkRead = {
      messageId: message.id,
      messageThreadId: message.threadId,
    };
    await providers.MessageThreadsProvider.markRead({ data });
    emitter.emit(EVENTS.MESSAGES_MARKED_READ, message);
  };
  onMounted(() => emitter.on<Message>(EVENTS.MESSAGES_MARK_READ, markRead));
  onUnmounted(() => emitter.off<Message>(EVENTS.MESSAGES_MARK_READ, markRead));
}
